// extracted by mini-css-extract-plugin
export var bottomWave = "by_cT";
export var button = "by_cb";
export var buttonContainer = "by_N";
export var buttonFooter = "by_gh";
export var container = "by_h";
export var middleWave = "by_cS";
export var section = "by_b";
export var subtitle = "by_cV";
export var textContainer = "by_bZ";
export var title = "by_f";